import React from 'react';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
 

  function Toastify(){
    return (
      <div>
        <ToastContainer/>
      </div>
    );
  }

  export default Toastify